<template>
  <div class="main">
    <el-form :model="queryParams" ref="queryForm" :inline="true" class="demo-form-inline">
      <el-form-item size="small" prop="country">
        <el-select filterable v-model="queryParams.country" placeholder="区域国家" clearable="clearable">

          <el-option :label="item.zh_name" :value="item.id" v-for="(item,index) in countyList" :key="index">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item size="small" prop="payStatus" clearable="clearable">
        <el-select v-model="queryParams.payStatus" placeholder="支付状态">
          <el-option label="全部" value="-1" />
          <el-option label="未支付" value="0" />
          <el-option label="已支付" value="1" />
        </el-select>
      </el-form-item>

      <el-form-item size="small" prop="orderStatus" clearable="clearable">
        <el-select v-model="queryParams.orderStatus" placeholder="订单状态">
          <el-option label="全部" value="-2" />
          <el-option label="待确认" value="0" />
          <el-option label="待资料" value="504" />
          <el-option label="待审核" value="501" />
          <el-option label="需补资料" value="10" />
          <el-option label="操作中" value="503" />
          <el-option label="待出签" value="7" />
          <!-- <el-option label="待送签" value="503" />
          <el-option label="失败" value="5" /> -->

          <!-- <el-option label="待返回" value="5" /> -->
          <!-- <el-option label="待评价" value="6" /> -->
          <el-option label="已完成" value="8" />
          <el-option label="拒签" value="11" />
        </el-select>
      </el-form-item>

      <el-form-item size="small" prop="orderNo">
        <el-input v-model="queryParams.orderNo" placeholder="姓名或单号" clearable="clearable" />
      </el-form-item>

      <el-form-item size="small">
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <div id="order" v-for="(item,index) in ListData" :key="index" style="margin-top: 20px;">
      <div class="row row1 clearfix" style="border-bottom:1px solid #e5e5e5" :id="'div_' + item.Id">

        <div class="col-md-12 column">
          <div style="display:flex;justify-content: space-between;">
            <div style="font-size:14px;color:#414141;width:800px;display: flex;align-items: center;">
              订单号：{{item.OrderNo}}（{{item.VisaTitle}}）

            </div>
            <div>

              <!-- 	<span v-if="item.PaymentStatus != 1" style="font-size: 14px;margin-right: 26px;">
								<i v-if="item.PaymentStatus==0 && item.Status == 0" v-on:click="DeleteOrder(item.Id)"
									class="el-icon-delete" style="margin-right:20px"></i>
								订单状态：{{GetStatus(item.Status)}}</span> -->
            </div>
          </div>

          <el-table :data="item.ListMember" border style="width: 100%;margin-top: 20px;"
            :span-method="(({row, column, rowIndex, columnIndex}) => objectSpanMethod({row, column, rowIndex, columnIndex},item.ListMember))">
            <el-table-column prop="PassengerName" label="姓名" width="190">
            </el-table-column>
            <el-table-column prop="PeopleType" label="工作类型" width="190">
            </el-table-column>

            <el-table-column label="支付状态" width="190">
              <template slot-scope="scope">
                <span>
                  <!-- <el-link type="primary">{{GetPayStatus(item.PaymentStatus)}}</el-link> -->
                  {{GetPayStatus(item.PaymentStatus)}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="订单状态" width="190">
              <template slot-scope="scope">
                <span v-if="scope.row.Status != 506">
                  <!-- <el-link type="primary">{{GetStatus(scope.row.Status)}}</el-link> -->
                  {{GetStatus(scope.row.Status)}}
                </span>
                <span v-else>
                  <el-link type="primary">
                    <a target="_blank" style="color:currentColor;text-decoration:none"
                      :href="scope.row.visapagepdf?scope.row.visapagepdf:scope.row.visapage">下载签证页</a>

                  </el-link>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="上传资料" width="190">
              <template slot-scope="scope">
                <el-link type="primary" @click="navTo(scope.row.Url)">上传资料
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="上传资料" width="100">
              <template slot-scope="scope">
                <span @click="show(scope.row.PassengerId)">
                  <el-link type="primary">查看进程</el-link>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="86">
              <template slot-scope="scope">
                <span class="" @click="DeleteOrder(item.Id)"
                  v-if="item.Status != -1 && (item.PaymentStatus==0 && item.Status == 0)">
                  <el-link type="danger">删除</el-link>
                </span>
                <span class="" v-if="item.PaymentStatus == 1">
                  <el-link type="danger" disabled>删除</el-link>
                </span>
              </template>
            </el-table-column>
          </el-table>


          <div class="order-footer" v-if="item.PaymentStatus != 1">
            <div class="order-footer-l text-center">
            </div>
            <div class="order-footer-c text-center" style="display: flex;
    justify-content: flex-end;margin:1.25rem 0">
              <div>
                <span style=" font-size: 16px;color:#ff8033">合计:</span><span
                  style="font-size:20px;color:#ff8033">￥{{towNumber(item.GetMoney-item.FinishGetMoney)}}</span>
              </div>
              <el-button style="margin:0 20px" type="warning" size="small">
                <a style="text-decoration: none;color: #fff" target="_blank" :href="'/orderpay?orderId=' + item.Id">立即支付
                </a>

              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-pagination :current-page="currentPage" @current-change="handleCurrentChange" :page-size="10"
      layout="total, prev, pager, next, jumper" :total="total">
    </el-pagination>

    <div class="" v-if="ListData.length == 0">
      <el-empty description="暂无数据"></el-empty>
    </div>

    <el-dialog class="orderDialog" width="533.4px" title="订单流程" v-loading="loading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      :visible.sync="isItemType">
      <el-timeline>
        <el-timeline-item :color="index2 == 0 ? 'blue' : 'gray'" v-for="(item2,index2) in handleTypeData"
          :icon="index2 == 0 ? 'el-icon-circle-check':''" :key="index2">
          <div style="display: flex;">
            <div style="display: flex;">
              <span style="white-space: nowrap;">{{item2.Zh}}
                {{item2.Operator}}{{item2.OperatorTime}}</span>
              <br />
            </div>
            <div class="typeItem_right">
              <div v-html="item2.Remark"></div>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>

      <div class="typeItem_right">
        <div style="margin-bottom: 10px;" v-for="(item3,index3) in remarkList" :key="index3">
          <div v-html="item3"></div>
        </div>
      </div>
    </el-dialog>
    <paydialog :paytype="1" :paytypeVisible="paytypeVisible" :cashAmount="cashAmount" :orderId="orderId"
      @onClosed="payClosed">

    </paydialog>
  </div>
</template>

<script>
  import paydialog from '../paydialog/paydialog.vue'
  export default {
    components: {
      paydialog
    },
    name: 'vsaorder',
    props: {
      orderStatus: {
        type: String,
      },
      payStatus: {
        type: String,
      }
    },
    data() {
      return {
        queryParams: {
          orderNo: '',
          orderStatus: '-2',
          payStatus: '-1',
          country: '',
        },
        countyList: [],
        ListData: [],
        isItemType: false,
        handleTypeData: [],
        remarkList: [],
        x: 0,
        y: 500,
        flag: [],
        loading: false,
        paytypeVisible: false,
        cashAmount: 0,
        orderId: '',
        currentPage: 1,
        total: 0

      }
    },
    created() {
      this.getlist()
      this.getCountryList()
    },
    watch: {
      orderStatus(newVal) {
        console.log(newVal)
        this.queryParams.orderStatus = newVal || "-2"
        this.getlist()
      },
      payStatus(newVal) {
        console.log(newVal)
        this.queryParams.payStatus = newVal || "0"
        this.getlist()
      }
    },

    methods: {
      getCountryList() {
        this.$api.GetCountryList().then(res => {
          this.countyList = res.data.data
        })
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getlist()
      },
      navTo(url) {
        url = url.replaceAll("&", "%26");
        var a = document.createElement("a");
        a.setAttribute("href", "/h5?url=" + url);
        a.setAttribute("target", "_blank");
        a.click();
      },

      objectSpanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }, value) {
        console.log(row, column, rowIndex, columnIndex, value)
        if (columnIndex === 6) {
          if (rowIndex === 0) {
            return {
              rowspan: value.length,
              colspan: 1,
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            }
          }
        } else if (columnIndex === 2) {
          if (rowIndex === 0) {
            return {
              rowspan: value.length,
              colspan: 1,
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            }
          }
        }
      },

      resetQuery() {
        this.queryParams = {
          orderNo: '',
          orderStatus: '-2',
          payStatus: '-1'
        }
      },
      handleQuery: function () {
        this.getlist()
      },
      getlist() {
        var param = {
          // Status=0&PayStatus=0&No=
          Status: this.queryParams.orderStatus,
          PayStatus: this.queryParams.payStatus,
          No: this.queryParams.orderNo,
          Country: this.queryParams.country,
          MemberId: cookie.get('MemberId'),
          pageIndex: this.currentPage,
          pageSize: 10
        }
        this.$api.GetOrderList(param).then(res => {
          console.log('%cvsaorder.vue line:60 orderlist', 'color: #007acc;', res);

          if (res.data.result) {
            this.ListData = res.data.data.data
            this.total = res.data.data.total
          } else {
            this.ListData = []
          }
        }).catch(err => {
          this.ListData = []
        })
      },
      towNumber(val) {
        return val.toFixed(2)
      },
      urlencode(str) {
        str = (str + '').toString();

        return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
        replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
      },
      DeleteOrder(id) {
        this.$confirm('此操作将撤销订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$api.CancelOrder({
            id: id
          }).then(res => {
            if (res.data.result) {
              this.$message({
                message: '撤销订单成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: '撤销订单失败',
                type: 'error'
              })
            }
            this.getlist()
          }).catch(err => {
            this.$message({
              message: '撤销订单失败',
              type: 'error'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤销订单'
          });
        });
      },
      GetStatus(status) {

        var str = '';
        if (status == '0' || status == '1')
          str = '待确认'
        else if (status == '501' || status == '1001' || status == '1000')
          str = '待审核'
        else if (status == '10')
          str = '需补资料'
        else if (status == '11')
          str = '拒签'
        else if (status == '7' || status == '601')
          str = '待出签'
        else if (status == '503' || status == '505')
          str = '操作中'
        else if (status == '504')
          str = '待资料'
        else if (status == '5')
          str = '失败'
        else if (status == '8' || status == '508' || status == '506' || status == '507')
          str = '已完成'
        return str;
      },
      GetPayStatus(status) {
        var str = '';
        if (status == '0')
          str = '未支付';
        else if (status == '1')
          str = '已支付';
        else if (status == '2')
          str = '部分支付';
        return str;
      },
      pay(item) {
        this.cashAmount = item.GetMoney - item.FinishGetMoney
        this.paytypeVisible = true;
        this.orderId = item.Id
      },
      payClosed() {
        this.paytypeVisible = false;
        this.cashAmount = 0;
      },
      show(id, e) {
        this.loading = true;

        this.handleTypeData = [];
        this.remarkList = [];
        let that = this;
        this.isItemType = true;

        this.$api.GetPassengerProgress({
          passengerId: id
        }).then(res => {
          if (res.data) {
            let list = []
            // for (let i in res.data.data) {
            //   list.unshift(res.data.data[i])
            // }
            for (let i in res.data.data) {
              for (let x in list) {
                if (res.data.data[i].Status == list[x].Status && list[x].Status != "" && res.data.data[i].Status !=
                  "") {
                  list.splice(x, 1)
                }
              }
              list.unshift(res.data.data[i])
              console.log(list);
            }
            this.handleTypeData = list
            that.handleTypeData = list;
            that.loading = false;
          }
        })
      },
      handleTypeHoverOut(index) {
        this.isItemType = false;
      }
    }
  }

</script>

<style lang="less" scoped>
  /deep/ .cell {
    text-align: center;
  }

  [v-cloak] {
    display: none
  }

  .main {
    text-align: left;
    margin: 20px auto;
    background-color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
  }

  .typeItem_box {
    width: 600px;
    position: absolute;
    z-index: 9;
    border: solid 1px #2799ff;
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    border-radius: 10px;
  }

  .typeItem_right {
    width: 300px;
    min-height: 30px;
    font-size: 14px;
    margin-left: 20px;
    margin-top: -5px;
  }

  .orderDialog {
    /deep/ .el-dialog {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -80%);
      margin: 0 !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/orderlist/vsaorder.vue